import { InputAdornment, TextField } from '@mui/material';
import { get } from 'lodash';
import React, { FC, useMemo, useRef, useState } from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { MUIFieldProps } from '../../../../../lib/types/types';
import { Help } from '@mui/icons-material';
import MUIToolTip from '../../../mui-tooltip/MUIToolTip';

const MUINumberField: FC<MUIFieldProps> = (props) => {
	const { label, tooltip, fieldValue, updateFieldValue, isDisabled, error, errorMessage, ...restProps } = props;

	const [inputValue, setInputValue] = useState(fieldValue);

	useMemo(() => {
		setInputValue(fieldValue !== undefined && fieldValue !== null ? fieldValue : '');
	}, [fieldValue]);

	const timeoutRef: { current: NodeJS.Timeout | null } = useRef(null);

	const debouncedOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		// Clear pending timeout if exists
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}

		// Sanitize input: keep only digits, dot, and minus
		let inputValue = e.target.value || '';
		let strapiValue = inputValue.replace(/[^0-9.-]/g, '');

		if (get(props, 'maxDigit')) {
			strapiValue = strapiValue.slice(0, get(props, 'maxDigit'));
		}

		setInputValue(strapiValue);

		// Schedule debounced update to field value
		timeoutRef.current = setTimeout(() => {
			const event = { target: { value: strapiValue } };
			updateFieldValue(event as React.ChangeEvent<HTMLInputElement>);
		}, 10);
	};

	return (
		<>
			<TextField
				label={
					tooltip ? (
						<>
							<>{label}</>
							<MUIToolTip title={tooltip}>
								{' '}
								<Help fontSize="small" color="primary" sx={{ ml: '5px' }} />{' '}
							</MUIToolTip>
						</>
					) : (
						<>{label}</>
					)
				}
				value={inputValue}
				onChange={debouncedOnChange}
				disabled={isDisabled}
				error={error}
				helperText={errorMessage}
				fullWidth
				InputProps={{
					startAdornment: get(props, 'format', '') === 'currency' ? <InputAdornment position="start">€</InputAdornment> : '',
					inputComponent:
						get(props, 'format', '') === 'currency' || get(props, 'type', '') === 'decimal'
							? (NumericFormatCustom as any)
							: '',
				}}
				inputProps={{
					sx: {
						textAlign: 'right',
						...get(props, 'inputProps.sx', {}),
					},
					...get(props, 'inputProps', {}),
				}}
				{...restProps}
			/>
		</>
	);
};
export default MUINumberField;

interface CustomProps {
	onChange: (event: { target: { name: string; value: string } }) => void;
	name: string;
}
const NumericFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(function NumericFormatCustom(props, ref) {
	const { onChange, ...other } = props;

	const handleValueChange = (values: any) => {
		onChange({
			target: {
				name: props.name,
				value: values.value,
			},
		});
	};

	return (
		<NumericFormat
			{...other}
			getInputRef={ref}
			onValueChange={handleValueChange}
			thousandSeparator="."
			decimalSeparator=","
			decimalScale={2}
			fixedDecimalScale
			valueIsNumericString
		/>
	);
});
